import Vue from 'vue'
import Vuex, { Store } from 'vuex'
import { Menu } from "@/modules/Menu";
import { MainteInfo } from "@/modules/MainteInfo";
import createPersistedState from 'vuex-persistedstate';
import * as Common from '../commons/common';
import { CbtSheetListCondition } from "../modules/teacher/CbtSheetList";
import { EntranceSheetListCondition } from "../modules/teacher/EntranceSheetList";
import { PracticeSheetListCondition } from "../modules/teacher/PracticeSheetList";
import router from "@/router/index";
import isMobileJS from 'ismobilejs'
import { SumupListCondition } from '@/modules/teacher/SumupList';

Vue.use(Vuex)

export type StateType = {
  currentUser: any
  isShowOverlay: boolean
  overlayText: string
  schools: any[]
  curriculums: any[]
  viewPoints: any[]
  grades: any[]
  months: any[]
  roles: any[]
  teacherRoles: any[]
  entranceTeacherRoles: any[]
  correct_texts: any[]
  digital_answer_types: any[]
  scoring_types: any[]
  assessment_score_types: any[]
  applied_types: any[]
  sheetType: number
  sheetListCondition: any
  cbtSheetListCondition: CbtSheetListCondition
  entranceSheetListCondition: EntranceSheetListCondition
  practiceExamSheetListCondition: PracticeSheetListCondition
  sumupListCondition: SumupListCondition
  isMobile: boolean,
  isHeaderDisp: boolean,
  mainteInfo: MainteInfo,
  defaultSheetType: number,
  otp_login_id: string,
  sumupResultCurriculumId: number
  sumupDetailCurriculumId: number
  gauthCredentials: string,
  gauthRedirectPath: string,
  isDigitalPaper: boolean,
  digitalPaperEmail: string
  isKaitouViewReloaded: boolean
  isShowingMsgBox: boolean
  student_no_character: string
  sumup_units: any[]
  practiceCurriculumIds: number[]
  nendo: string
  exec_times: string
  practice_examinee_id: number
  base64_school_logo: string
  practiceExaminee: any,
  sumup_group_id: string
  sumup_group: any
}

export default new Vuex.Store({
  state: {
    currentUser: null,
    isShowOverlay: false,
    overlayText: "",
    schools: [],
    curriculums: [],
    viewPoints: [],
    grades: Common.GetComboboxGradeArray(),
    months: Common.GetComboboxMonthArray(),
    roles: Common.GetComboboxRoleArray(),
    teacherRoles: Common.GetComboboxTeacherRoleArray(),
    entranceTeacherRoles: Common.GetComboboxEntranceTeacherRoleArray(),
    correct_texts: Common.GetComboboxCorrectTextArray(),
    scoring_types: Common.GetComboboxScoingTypeArray(),
    digital_answer_types: Common.GetComboboxDigitalAnswerTypeArray(),
    applied_types: Common.GetComboboxAppliedTypeArray(),
    assessment_score_types: Common.GetComboboxAssessmentScoreTypeArray(),
    sheetType: 0,
    sheetListCondition: {
      grade: "",
      month: "",
      sheet_group_key: "",
      curriculum_id: "",
      saiten_flg: "",
      page: 1,
      row_count: Common.SheetListRowCount,
    },
    cbtSheetListCondition: new CbtSheetListCondition(),
    entranceSheetListCondition: new EntranceSheetListCondition(),
    practiceExamSheetListCondition: new PracticeSheetListCondition(),
    sumupListCondition: new SumupListCondition(),
    isMobile: isMobileJS(window.navigator).phone || isMobileJS(window.navigator).tablet,
    isHeaderDisp: true,
    mainteInfo: new MainteInfo([]),
    defaultSheetType: 0,
    otp_login_id: "",
    gauthCredentials: "",
    gauthRedirectPath: "",
    isDigitalPaper: false,
    digitalPaperEmail: null,
    isKaitouViewReloaded: false,
    isShowingMsgBox: false,
    student_no_character: null,
    sumup_units: [],
    practiceCurriculumIds: [],
    nendo: null,
    exec_times: null,
    practice_examinee_id: null,
    base64_school_logo: null,
    practiceExaminee: null,
    sumup_group_id: null,
  } as StateType,
  mutations: {
    setCurrentUser(state, user: any){
      state.currentUser = user;
    },
    setCurrentUserSchoolId(state, school_id: any){
      state.currentUser.school_id = school_id;
    },
    setCurrentUserSchoolOptions(state, school_options: any){
      state.currentUser.school_options = school_options;
    },
    setSchools(state, schools: []){
      state.schools = schools;
    },
    setCurriculums(state, curriculums: []){
      state.curriculums = curriculums;
    },
    setViewPoints(state, viewPoints: []){
      state.viewPoints = viewPoints;
    },
    setSheetListCondition(state, condition: {}){
      state.sheetListCondition = condition;
    },
    setCbtSheetListCondition(state, condition: CbtSheetListCondition){
      state.cbtSheetListCondition = condition;
    },
    setEntranceSheetListCondition(state, condition: EntranceSheetListCondition){
      state.entranceSheetListCondition = condition;
    },
    setPracticeSheetListCondition(state, condition: PracticeSheetListCondition){
      state.practiceExamSheetListCondition = condition;
    },
    setSumupListCondition(state, condition: SumupListCondition){
      state.sumupListCondition = condition;
    },
    setIsShowOverlay(state, isShow: boolean){
      state.isShowOverlay = isShow;
    },
    setOverlayText(state, text: string){
      state.overlayText = text;
    },
    setSheetType(state, sheetType: number){
      state.sheetType = sheetType;
    },
    setIsHeaderDisp(state, isHeaderDisp: boolean){
      state.isHeaderDisp = isHeaderDisp;
    },
    setMainteInfo(state, mainteInfos: any[]){
      state.mainteInfo = new MainteInfo(mainteInfos);
    },
    setDefaultSheetType(state, sheetType: number){
      state.defaultSheetType = sheetType;
    },
    setOtpLoginId(state, otp_login_id: string){
      state.otp_login_id = otp_login_id;
    },
    setSumupResultCurriculumId(state, curriculumId: number){
      state.sumupResultCurriculumId = curriculumId;
    },
    setSumupDetailCurriculumId(state, curriculumId: number){
      state.sumupDetailCurriculumId = curriculumId;
    },
    setGauthCredentials(state, credentials: string){
      state.gauthCredentials = credentials;
    },
    setGauthRedirectPath(state, path: string){
      state.gauthRedirectPath = path;
    },
    setIsDigitalPaper(state, isDigitalPaper: boolean){
      state.isDigitalPaper = isDigitalPaper;
    },
    setDigitalPaperEmail(state, email: string){
      state.digitalPaperEmail = email;
    },
    setIsKaitouViewReloaded(state, value){
      state.isKaitouViewReloaded = value;
    },
    setIsShowingMsgBox(state, isShowingMsgBox: boolean){
      state.isShowingMsgBox = isShowingMsgBox;
    },
    setStudentNoCharacter(state, student_no_character: string){
      state.student_no_character = student_no_character;
    },
    setSumupUnits(state, sumup_units: any[]){
      state.sumup_units = sumup_units;
    },
    setPracticeCurriculumIds(state, curriculum_ids: any[]){
      state.practiceCurriculumIds = curriculum_ids;
    },
    setNendo(state, nendo: string){
      state.nendo = nendo;
    },
    setExecTimes(state, times: string){
      state.exec_times = times;
    },
    setPracticeExamineeId(state, practice_examinee_id: number){
      state.practice_examinee_id = practice_examinee_id;
    },
    setBase64SchoolLogo(state, base64_school_logo: string){
      state.base64_school_logo = base64_school_logo;
    },
    setPracticeExaminee(state, practiceExaminee: any){
      state.practiceExaminee = practiceExaminee;
    },
    setSumupGroupId(state, sumup_group_id: any){
      state.sumup_group_id = sumup_group_id;
    },
    setSumupGroup(state, sumup_group: any){
      state.sumup_group = sumup_group;
    },
  },
  getters: {
    // 教科プルダウン
    getComboboxCurriculums: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      for(const curriculum of state.curriculums){
        rtn.push({value: curriculum.id, text: curriculum.name});
      }
      return rtn;
    },
    // 自分の担当教科プルダウン
    getComboboxMyCurriculums: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(state.currentUser.role == Common.RoleEnum.Teacher2 || state.currentUser.role == Common.RoleEnum.EntranceTeacher2){
        const curriculum_ids = state.currentUser.curriculum_id.split(",");
        if(allowEmpty){
          rtn.push({value: "", text: "-"});
        }
        for(const curriculum of state.curriculums){
          if(curriculum_ids.includes(`${curriculum.id}`)){
            rtn.push({value: curriculum.id, text: curriculum.name});
          }
        }
      }else{
        if(allowEmpty){
          rtn.push({value: "", text: "-"});
        }
        for(const curriculum of state.curriculums){
          rtn.push({value: curriculum.id, text: curriculum.name});
        }
      }
      return rtn;
    },
    // 観点プルダウン
    getComboboxViewPoints: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: null, text: "-"});
      }
      for(const viewPoint of state.viewPoints){
        rtn.push({value: viewPoint.id, text: `${viewPoint.id} : ${viewPoint.name}`});
      }
      return rtn;
    },
    // 実施月プルダウン
    getComboboxMonths: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      return rtn.concat(state.months);
    },
    // 学年プルダウン
    getComboboxGrades: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      return rtn.concat(state.grades);
    },
    // 試験一覧の学校プルダウン
    getComboboxSchools: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      for(const school of state.schools){
        rtn.push({value: school.id, text: `${school.id} : ${school.name}`});
      }
      return rtn;
    },
    // 正答プルダウン
    getComboboxCorrectTexts: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: null, text: "-"});
      }
      return rtn.concat(state.correct_texts);
    },
    // 採点方法プルダウン
    getComboboxScoringTypes: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: null, text: "-"});
      }
      return rtn.concat(state.scoring_types);
    },
    // 解答方法プルダウン
    getComboboxDigitalAnswerTypes: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: null, text: "-"});
      }
      return rtn.concat(state.digital_answer_types);
    },
    getCurriculumNameById: (state) => (id: number) => {
      const curriculum = state.curriculums.filter(x => x.id == id);

      if(curriculum.length == 0){
        if(id == Common.SougouCurriculumIdEnum.Two){
          return Common.SougouCurriculumNameEnum.Two;
        }else if(id == Common.SougouCurriculumIdEnum.Three){
          return Common.SougouCurriculumNameEnum.Three;
        }else if(id == Common.SougouCurriculumIdEnum.Four){
          return Common.SougouCurriculumNameEnum.Four;
        }else{
          return "-";
        }
      }else if(window.location.href.includes("candidate") && curriculum[0].id == 2){
        return "算数";
      }else if(state.sheetType == Common.SheetTypeEnum.Practice && curriculum[0].id == 2){
        return "算数";
      }else{
        return curriculum[0].name;
      }
    },
    getViewPointNameById: (state) => (id: number) => {
      const viewPoint = state.viewPoints.filter(x => x.id == id);
      return viewPoint.length > 0 ? viewPoint[0].name : "-";
    },
    getGradeNameByValue: (state, getters) => (value: number) => {
      if(getters.isEntranceOrPractice){
        return state.sheetType == Common.SheetTypeEnum.Entrance ? "入試" : "模試";
      }else{
        const grade = state.grades.filter(x => x.value == value);
        return grade.length > 0 ? grade[0].text : "-";
      }
    },
    getComboboxRoles: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      return rtn.concat(state.roles);
    },
    getComboboxTeacherRoles: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      return rtn.concat(state.teacherRoles);
    },
    getComboboxEntranceTeacherRoles: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      return rtn.concat(state.entranceTeacherRoles);
    },
    getComboboxAppliedTypes: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: null, text: "-"});
      }
      return rtn.concat(state.applied_types);
    },
    getComboboxAssessmentScoreTypes: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      return rtn.concat(state.assessment_score_types);
    },
    getRoleNameByValue: (state) => (value: string) => {
      const role = state.roles.filter(x => x.value == value);
      return role.length > 0 ? role[0].text : "-";
    },
    getAppliedTypeNameByCode: (state) => (value: string) => {
      const applied_type = state.applied_types.filter(x => x.value == value);
      return applied_type.length > 0 ? applied_type[0].text : "-";
    },
    // 生徒管理オプション有無
    isOptionStudentManageActive: state => {
      return state.currentUser.school_options.filter((x: any) => x.option_no == Common.SchoolOptionEnum.StudentManage && x.active_flg).length > 0;
    },
    // CBT試験オプション有無
    isOptionCbtActive: state => {
      return state.currentUser.school_options.filter((x: any) => x.option_no == Common.SchoolOptionEnum.Cbt && x.active_flg).length > 0;
    },
    // 入試オプション有無
    isOptionEntranceActive: state => {
      return state.currentUser.school_options.filter((x: any) => x.option_no == Common.SchoolOptionEnum.Entrance && x.active_flg).length > 0;
    },
    // Classroomオプション有無
    isOptionClassroomActive: state => {
      return state.currentUser.school_options.filter((x: any) => x.option_no == Common.SchoolOptionEnum.Classroom && x.active_flg).length > 0;
    },
    // デジタルペーパーオプション有無
    isOptionDigitalPaperActive: state => {
      return state.currentUser.school_options.filter((x: any) => x.option_no == Common.SchoolOptionEnum.DigitalPaper && x.active_flg).length > 0;
    },
    // メール返却オプション有無
    isOptionMailReturnActive: state => {
      return state.currentUser.school_options.filter((x: any) => x.option_no == Common.SchoolOptionEnum.MailReturn && x.active_flg).length > 0;
    },
    // 模試オプション有無
    isOptionPracticeActive: state => {
      return state.currentUser.school_options.filter((x: any) => x.option_no == Common.SchoolOptionEnum.Practice && x.active_flg).length > 0;
    },
    // ヘッダメニュー 権限・オプションにより制御
    headerMenus: (state, getters) => {
      
      const menus: Menu[] = new Array<Menu>();
      
      if(state.currentUser == null){
        return menus;
      }

      if(state.currentUser.role == Common.RoleEnum.Student){
        // 生徒系のメニュー
        menus.push(new Menu("パスワード変更", "address-card", `/${state.currentUser.school_id}/student_site/password_edit`));
        menus.push(new Menu("メールアドレス変更", "address-card", `/${state.currentUser.school_id}/student_site/mail_edit`));
      }else{
        // 教師系のメニュー
        menus.push(new Menu("ユーザー管理", "address-card", "/teacher_site/user_edit"));
        
        if(state.currentUser.role == Common.RoleEnum.Admin){
          // admin権限
          menus.push(new Menu("試験一覧", "file-alt", "/teacher_site/sheet_list"));
          if(getters.isOptionCbtActive){
            menus.push(new Menu("試験一覧（CBT）", "file-alt", "/teacher_site/cbt_sheet_list"));
          }
          // entrance_teacher1権限
          // if(getters.isOptionEntranceActive){
          //   menus.push(new Menu("試験一覧（入試）", "file-alt", "/teacher_site/entrance_sheet_list"));
          //   menus.push(new Menu("集計（入試）", "file-alt", "/teacher_site/sumup_list"));
          // }
          menus.push(new Menu("試験一覧（中学入試）", "file-alt", "/teacher_site/practice_sheet_list"));
          menus.push(new Menu("集計（中学入試）", "file-alt", "/teacher_site/practice_sumup_list"));
          menus.push(new Menu("合否通知登録", "file-alt", "/teacher_site/exam_result_notification_list"));
          menus.push(new Menu("学校一覧", "calendar-alt", "/teacher_site/school_list"));
          
          if(getters.isOptionEntranceActive){
            menus.push(new Menu("教師一覧(通常)", "graduation-cap", "/teacher_site/teacher_list"));
            menus.push(new Menu("教師一覧(入試)", "graduation-cap", "/teacher_site/entrance_teacher_list"));
          }else{
            menus.push(new Menu("教師一覧(通常)", "graduation-cap", "/teacher_site/teacher_list"));
          }
          if(getters.isOptionStudentManageActive){
            menus.push(new Menu("生徒一覧", "graduation-cap", "/teacher_site/student_list"));
            menus.push(new Menu("年度切替", "graduation-cap", "/teacher_site/nendo_edit"));
            menus.push(new Menu("個別PDF", "upload", "/teacher_site/student_file_upload_list"));
          }
        }else if(state.currentUser.role == Common.RoleEnum.Teacher1){
          // teacher1権限
          menus.push(new Menu("試験一覧", "file-alt", "/teacher_site/sheet_list"));
          if(getters.isOptionCbtActive){
            menus.push(new Menu("試験一覧（CBT）", "file-alt", "/teacher_site/cbt_sheet_list"));
          }
          if(getters.isOptionEntranceActive){
            menus.push(new Menu("教師一覧(通常)", "graduation-cap", "/teacher_site/teacher_list"));
            menus.push(new Menu("教師一覧(入試)", "graduation-cap", "/teacher_site/entrance_teacher_list"));
          }else{
            menus.push(new Menu("教師一覧", "graduation-cap", "/teacher_site/teacher_list"));
          }
          if(getters.isOptionStudentManageActive){
            menus.push(new Menu("生徒一覧", "graduation-cap", "/teacher_site/student_list"));
            menus.push(new Menu("年度切替", "graduation-cap", "/teacher_site/nendo_edit"));
            menus.push(new Menu("個別PDF", "upload", "/teacher_site/student_file_upload_list"));
          }
        }else if(state.currentUser.role == Common.RoleEnum.Teacher2){
          // teacher2権限
          menus.push(new Menu("試験一覧", "file-alt", "/teacher_site/sheet_list"));
          if(getters.isOptionCbtActive){
            menus.push(new Menu("試験一覧（CBT）", "file-alt", "/teacher_site/cbt_sheet_list"));
          }
        }else if(state.currentUser.role == Common.RoleEnum.EntranceTeacher1){
          // entrance_teacher1権限
          // if(getters.isOptionEntranceActive){
          //   menus.push(new Menu("試験一覧（入試）", "file-alt", "/teacher_site/entrance_sheet_list"));
          //   menus.push(new Menu("集計（入試）", "file-alt", "/teacher_site/sumup_list"));
          // }
          menus.push(new Menu("試験一覧（中学入試）", "file-alt", "/teacher_site/practice_sheet_list"));
          menus.push(new Menu("集計（中学入試）", "file-alt", "/teacher_site/practice_sumup_list"));
          
          menus.push(new Menu("合否通知登録", "file-alt", "/teacher_site/exam_result_notification_list"));

          if(getters.isOptionEntranceActive){
            menus.push(new Menu("教師一覧(入試)", "graduation-cap", "/teacher_site/entrance_teacher_list"));
          }else{
            menus.push(new Menu("教師一覧", "graduation-cap", "/teacher_site/teacher_list"));
          }
        }else if(state.currentUser.role == Common.RoleEnum.EntranceTeacher2){
          menus.push(new Menu("試験一覧（中学入試）", "file-alt", "/teacher_site/practice_sheet_list"));
        }
      }
      return menus;
    },
    // システム管理者か判定
    isAdmin: state => {
      return state.currentUser.role == Common.RoleEnum.Admin;
    },
    isTeacher1: state => {
      return state.currentUser.role == Common.RoleEnum.Teacher1 || state.currentUser.role == Common.RoleEnum.EntranceTeacher1;
    },
    isAdminOrTeacher1: state => {
      return state.currentUser.role == Common.RoleEnum.Admin || state.currentUser.role == Common.RoleEnum.Teacher1 || state.currentUser.role == Common.RoleEnum.EntranceTeacher1;
    },
    isEntranceOrPractice: state => {
      return state.sheetType == Common.SheetTypeEnum.Entrance || state.sheetType == Common.SheetTypeEnum.Practice;
    },
  },
  actions: {
    showOverlay(context, overlayText){
      context.commit("setIsShowOverlay", true);
      context.commit("setOverlayText", overlayText == null ? "処理実行中... しばらくお待ちください。" : overlayText);
    },
    hideOverlay(context){
      context.commit("setIsShowOverlay", false);
    },
    goSheetList(context){
      context.commit("setIsHeaderDisp", true);
      if(context.state.currentUser.role == Common.RoleEnum.Student){
        router.push(`/${context.state.currentUser.school_id}/student_site/sheet_list`);
      }else{
        if(context.state.sheetType == Common.SheetTypeEnum.Entrance){
          router.push('/teacher_site/entrance_sheet_list');
        }else if(context.state.sheetType == Common.SheetTypeEnum.Cbt){
          router.push('/teacher_site/cbt_sheet_list');
        }else if(context.state.sheetType == Common.SheetTypeEnum.Practice){
          router.push('/teacher_site/practice_sheet_list');
        }else{
          router.push('/teacher_site/sheet_list');
        }
      }
    },
    goSumupList(context){
      router.push("/teacher_site/practice_sumup_list");
    }
  },
  modules: {
  },
  plugins: [createPersistedState({
    storage: window.sessionStorage
  })],
})
